import { callApi } from '@/api/apibase'

export const deleteCustomerRegistrationRelation = function (id) {

  return callApi('DELETE',`/api/external/greencourse/deleteCustomerRegistrationRelation?relationid=${encodeURIComponent(id)}`)
}
